import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface OutcomeItem {
  title: string;
  description: string;
}

interface LabItem {
  title: string;
  image: string;
  description: string;
}

interface ProgrammeItem {
  sno: number;
  name: string;
  duration: string;
}

interface AssociationDetailItem {
  sno: number;
  activity: string;
  date: string;
  description: string;
}
interface AssociationPhotoItem {
  image: string;
  caption: string;
}

interface MouItem {
  sno: number;
  organization: string;
  date: string;
  purpose: string;
}

interface PlacementItem {
  sno: number;
  batch: string;
  studentName: string;
  designation: string;
  companyName: string;
}

interface IndustrialVisitItem {
  title: string;
  image: string;
  description: string;
}

interface ValueAddedCourseItem {
  sno: number;
  courseName: string;
  duration: string;
  companyName: string;
}

interface AlumniItem {
  name: string;
  batch: string;
  role: string;
  company: string;
  quote: string;
  image: string;
}

interface AchievementItem {
  sno: number;
  achiever: string;
  year: string;
  eventName: string;
  organizer: string;
  level: string;
  date: string;
  award: string;
}

interface NptelRecordItem {
  staffName: string;
  subject: string;
  grade: string;
  session: string;
}

interface FdpItem {
  sno: number;
  staffName: string;
  title: string;
  collegeName: string;
  date: string;
}

interface ConferenceItem {
  sno: number;
  conferenceName: string;
  paperTitle: string;
  authors: string[];
  collegeName: string;
  date: string;
}
interface CoursePhotoItem {
  image: string;
  caption: string;
}
interface MouPhotoItem {
  image: string;
  caption: string;
}
interface AchievementPhotoItem {
  image: string;
  caption: string;
}

@Component({
  selector: 'app-courses-grid-style-three-columns-three-page',
  templateUrl: './courses-grid-style-three-columns-three-page.component.html',
  styleUrls: ['./courses-grid-style-three-columns-three-page.component.scss']
})
export class CoursesGridStyleThreeColumnsThreePageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  departmentName = 'Department of Cyber Security';
  establishedYear = '2025';
  intake = '60';
  programmeSummary = '1 UG Programme';
  contactEmail = 'hodcyber@fmcet.ac.in';

  admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS), B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA, M.E. (CSE), M.E. (Embedded System Technologies), M.E. (Thermal Engineering), M.E. (Environmental Engineering)';

  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'About the Department' },
    { id: 'tab2', label: 'Vision & Mission' },
    { id: 'tab3', label: "PEO's" },
    { id: 'tab4', label: 'POs & PSOs' },
    { id: 'tab14', label: 'Programme Offered' },
    { id: 'tab5', label: 'Laboratory Facilities' },
    { id: 'tab6', label: 'Association Activities' },
    { id: 'tab7', label: "MoU's" },
    { id: 'tab8', label: 'Placement Record' },
    { id: 'tab9', label: 'Industrial Visit' },
    { id: 'tab10', label: 'Value Added Courses' },
    { id: 'tab11', label: 'Alumni' },
    { id: 'tab12', label: 'Achievements' },
    { id: 'tab13', label: 'NPTEL' },
    { id: 'tab15', label: 'Research' }
  ];

aboutParagraphs: string[] = [
  'The Department of Computer Science and Engineering (Cyber Security), established in the academic year 2023-2024 with an intake of 30 students, is committed to developing skilled professionals in secure computing, ethical hacking, cyber defense, and digital forensics.',
  'The department offers a well-structured four-year undergraduate program in Computer Science and Engineering (Cyber Security), combining core computer science fundamentals with specialized cyber security knowledge. The curriculum covers areas such as cryptography, network security, ethical hacking, cyber forensics, and web application security, with a strong focus on both theory and practical learning.',
  'Graduates are well-prepared for roles such as Cyber Security Analyst, Penetration Tester, Network Administrator, and Software Engineer. Supported by experienced faculty, the department ensures that students are equipped to meet evolving challenges in the field of cyber security and excel in diverse professional environments.'
];

quickFacts: FactItem[] = [
  {
    title: 'Programme',
    value: 'B.E. CSE (Cyber Security)'
  },
  {
    title: 'Academic Focus',
    value: 'Secure computing, ethical hacking, cyber defense, digital forensics, network security, cryptography, and web application security.'
  },
  {
    title: 'Learning Exposure',
    value: 'Hands-on laboratory practice, real-world projects, industrial visits, workshops, seminars, guest lectures, and value-added training programs.'
  },
  {
    title: 'Student Development',
    value: 'Skill enhancement through technical clubs, innovation-driven projects, leadership initiatives, and professional development activities.'
  }
];

visionText =
  'To be a recognized institution in Cyber Security, known for quality education, strong research, ethical practices, and developing secure and innovative solutions for future digital challenges.';
missionPoints: string[] = [
  'To provide high-quality technical education in Cyber Security with a strong foundation in computing principles, along with technical and analytical skills.',
  'To foster research, innovation, and professional excellence to develop secure technologies that contribute to the progress of society and the digital world.',
  'To equip students to adapt to evolving cyber threats and technological advancements with strong ethical values and professional responsibility.'
];
peos: string[] = [
  'PEO 1: Graduates will apply their technical expertise in Cyber Security to design, implement, and manage solutions for real-world challenges, demonstrating technical proficiency and leadership skills.',
  'PEO 2: Graduates will engage in research and innovation to develop secure technologies and solutions that address socially and globally relevant problems.',
  'PEO 3: Graduates will excel in professional environments by exhibiting teamwork, ethical conduct, adaptability, and a commitment to lifelong learning in the dynamic field of Cyber Security.'
];

  programOutcomes: OutcomeItem[] = [
    {
      title: 'Engineering Knowledge',
      description:
        'Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.'
    },
    {
      title: 'Problem Analysis',
      description:
        'Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.'
    },
    {
      title: 'Design / Development of Solutions',
      description:
        'Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health, safety, cultural, societal, and environmental considerations.'
    },
    {
      title: 'Conduct Investigations of Complex Problems',
      description:
        'Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of information to provide valid conclusions.'
    },
    {
      title: 'Modern Tool Usage',
      description:
        'Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of their limitations.'
    },
    {
      title: 'The Engineer and Society',
      description:
        'Apply reasoning informed by contextual knowledge to assess societal, health, safety, legal, and cultural issues and the consequent responsibilities relevant to professional engineering practice.'
    },
    {
      title: 'Environment and Sustainability',
      description:
        'Understand the impact of professional engineering solutions in societal and environmental contexts, and demonstrate the knowledge of, and need for sustainable development.'
    },
    {
      title: 'Ethics',
      description:
        'Apply ethical principles and commit to professional ethics, responsibilities, and norms of engineering practice.'
    },
    {
      title: 'Individual and Teamwork',
      description:
        'Function effectively as an individual, and as a member or leader in diverse teams and multidisciplinary settings.'
    },
    {
      title: 'Communication',
      description:
        'Communicate effectively on complex engineering activities with the engineering community and society at large through effective reports, design documentation, presentations, and clear instructions.'
    },
    {
      title: 'Project Management and Finance',
      description:
        'Demonstrate knowledge and understanding of engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects in multidisciplinary environments.'
    },
    {
      title: 'Life-long Learning',
      description:
        'Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.'
    }
  ];

programSpecificOutcomes: OutcomeItem[] = [
  {
    title: 'PSO 1',
    description:
      'Apply advanced design, programming, and automation skills to develop secure and innovative solutions for real-world cyber security challenges.'
  },
  {
    title: 'PSO 2',
    description:
      'Leverage a strong theoretical foundation to conduct research and provide effective, elegant solutions to complex problems in Cyber Security.'
  }
];
  programmes: ProgrammeItem[] = [
    {
      sno: 1,
      name: 'B.E. CSE (Cyber Security)',
      duration: '4 Years'
    }
  ];

  labs: LabItem[] = [
    {
      title: 'Cryptography and Cyber Security Lab',
      image: 'assets/img/cs/lab5.jpeg',
      description:
        'Provides practical knowledge of encryption techniques, secure communication, and cybersecurity practices to protect digital systems. Supports courses like Cryptography and Cyber Security.'
    },
    {
      title: 'Cyber Forensics Lab',
      image: 'assets/img/cs/lab6.jpeg',
      description:
        'Offers practical training in digital evidence collection, analysis, and investigation techniques using forensic tools. Supports courses like Cyber Forensics and Digital Investigation.'
    },
    {
      title: 'Network Security Lab',
      image: 'assets/img/cs/lab7.jpeg',
      description:
        'Focuses on implementing network security measures, intrusion detection, firewalls, and ethical hacking techniques. Supports courses like Network Security and Ethical Hacking.'
    }
  ];

  associationDetailRecords: AssociationDetailItem[] = [
    {
      sno: 1,
      activity: 'Seminar on “Cyber Security: Scope & Opportunities”',
      date: '22.08.2025',
      description:
        'Conducted with Er. RamSundar Suresh, Founder & Director, and Er. Dinesh Rajan S V, Security Analyst at Hebesec Technologies, Karaikudi.'
    },
    {
      sno: 2,
      activity: 'Artificial Intelligence & Machine Learning and its Applications',
      date: '06.02.2026',
      description:
        'Conducted with Mrs. V. Gayathiri, AP/IT, Kamaraj College of Engineering & Technology, Madurai.'
    },
    {
      sno: 3,
      activity: 'Building Intelligent Systems with Machine Learning',
      date: '27.02.2026',
      description:
        'Hands-on workshop conducted with Mrs. S. Athilakshmi and Mr. B. Muthu Krishnavinayagam, AP/CSE, Kamaraj College of Engineering & Technology, Madurai.'
    },
    {
      sno: 4,
      activity: 'Cyber Security Tools',
      date: '24.09.2025 to 25.09.2025',
      description:
        'Two days hands-on training conducted with Er. Dinesh Rajan S V, Security Analyst at Hebesec Technologies, Karaikudi.'
    },
    {
      sno: 5,
      activity: 'Insights into Network Layer and Routing Protocols',
      date: '06.10.2025',
      description:
        'Guest lecture conducted with Ms. Vanathi D, HOD/CSE, PSYEC, Sivagangai.'
    },
    {
      sno: 6,
      activity: 'Machine Learning Techniques & Applications',
      date: '09.10.2025',
      description:
        'Guest lecture conducted with Mrs. S. Athilakshmi, AP/CSE, Kamaraj College of Engineering & Technology, Madurai.'
    }
  ];

  mous: MouItem[] = [
    {
      sno: 1,
      organization: 'Reccsar Private Limited',
      date: '12.02.2026',
      purpose: 'Placement, Industrial Visit and Internship'
    }
  ];
  mouPhotos: MouPhotoItem[] = [
  {
    image: 'assets/img/cs/mou1.jpeg',
    caption: 'MoU Signed with Reccsar Private Limited on 12.02.2026'
  }
];

  placementRecords: PlacementItem[] = [];

  industrialVisits: IndustrialVisitItem[] = [
    {
      title: 'External Practical Learning at Mount Town Technology, Mettupalayam',
      image: 'assets/img/cs/iv1.jpeg',
      description:
        'Our department organized an External Practical Learning visit for III Year students at Mount Town Technology, Mettupalayam. The visit provided practical industrial exposure and helped students understand real-time professional practices in technology environments.'
    },
    {
      title: 'External Practical Learning at HCL Tech, Madurai',
      image: 'assets/img/cs/iv2.jpeg',
      description:
        'A one-day External Practical Learning visit was organized at HCL Tech, Madurai, for II and III Year students. The visit exposed students to professional work culture, industrial workflows, and current technology practices.'
    },
    {
      title: 'Visit to HCL Tech Campus, Madurai',
      image: 'assets/img/cs/iv3.jpeg',
      description:
        'Students gained direct exposure to the HCL Tech environment, industry interaction, and organizational practices during the educational visit.'
    },
    {
      title: 'Staff Industrial Training at Hebesec Technology, Karaikudi',
      image: 'assets/img/cs/iv4.jpeg',
      description:
        'A staff industrial training programme was organized at Hebesec Technology, Karaikudi, for faculty members. The training enhanced staff exposure to industrial practices, cyber security tools, and current professional requirements in secure computing.'
    }
  ];

  valueAddedCourses: ValueAddedCourseItem[] = [
    {
      sno: 1,
      courseName: 'Machine Learning Using Python',
      duration: '19.01.2026 to 23.01.2026',
      companyName: 'Reccsar Private Limited'
    },
    {
      sno: 2,
      courseName: 'Certified Ethical Hacking Practitioner',
      duration: '19.01.2026 to 23.01.2026',
      companyName: 'Hebesec Technologies, Karaikudi'
    }
  ];
  valueAddedCoursePhotos: CoursePhotoItem[] = [
  {
    image: 'assets/img/cs/vac1.jpeg',
    caption: 'Machine Learning Using Python, Reccsar Private Limited'
  },
  {
    image: 'assets/img/cs/vac2.jpeg',
    caption: 'Certified Ethical Hacking Practitioner, Hebesec Technologies, Karaikudi'
  }
];

  alumniRecords: AlumniItem[] = [];

  achievements: AchievementItem[] = [
    {
      sno: 1,
      achiever: 'Mathi Bala M, Periyamanikandan M, Aravind M, Jayakanthan G',
      year: 'III',
      eventName: 'IDEATHON',
      organizer: 'National Engineering College, Kovilpatti',
      level: 'State',
      date: '10.02.2026',
      award: 'First Prize (₹2,500 Cash Prize)'
    },
    {
      sno: 2,
      achiever: 'S. Abi, S. Varsha Sri',
      year: 'III',
      eventName: 'Milan’26 Contest',
      organizer: 'Mangayarkarasi College of Engineering, Madurai',
      level: 'State',
      date: '06.03.2026',
      award: 'Second Prize (₹15,000 Cash Prize)'
    }
  ];

  nptelRecords: NptelRecordItem[] = [
    {
      staffName: 'Mrs. K. Aparna Preethi',
      subject: 'OBE and ACCREDITATION',
      grade: 'Elite',
      session: '2025 - 2026'
    },
    {
      staffName: 'Mrs. G. Hemavathi',
      subject: 'OBE and ACCREDITATION',
      grade: 'Elite',
      session: '2025 - 2026'
    }
  ];
  achievementPhotos: AchievementPhotoItem[] = [
  {
    image: 'assets/img/cs/achi1.jpg',
    caption: 'Mathi Bala M and his team won First Prize in IDEATHON organized by National Engineering College, Kovilpatti on 10.02.2026'
  },
  {
    image: 'assets/img/cs/achi2.jpeg',
    caption: 'S.Abi and her team won second prize in Milan’26 Contest organized by Mangayarkarasi College of Engineering on 06.03.2026'
  }
];

  fdpRecords: FdpItem[] = [
    {
      sno: 1,
      staffName: 'M. Siva Ganesh',
      title: 'IPR Basics for Innovators and Entrepreneurs',
      collegeName: 'M. Kumarasamy College of Engineering, Karur',
      date: '12.02.2026'
    }
  ];

  conferenceRecords: ConferenceItem[] = [
    {
      sno: 1,
      conferenceName: 'International Conference on Applied Scientific Computational Intelligence using Digital Twins',
      paperTitle: 'Assessment of Cyber Security Risks in Digital Twin Deployments in Smart Cities in Indian Context',
      authors: ['Mrs. K. Aparna Preethi'],
      collegeName: 'Manipal University, Jaipur',
      date: '15.12.2025'
    },
    {
      sno: 2,
      conferenceName: 'National Conference on Innovations in AI, Machine Learning & Computer Science',
      paperTitle: 'Cyber Security Threats and Risks in the Age of Artificial Intelligence',
      authors: ['Mrs. K. Aparna Preethi', 'Mrs. G. Hemavathi'],
      collegeName: 'Bannari Amman Institute of Technology, Sathyamangalam',
      date: '24.01.2026'
    },
    {
      sno: 3,
      conferenceName: 'International Conference on Natural-Inspired Intelligence for Cyber & Industrial Systems',
      paperTitle: 'Cyber Security Affecting Online Banking',
      authors: ['Mrs. K. Aparna Preethi'],
      collegeName: 'Sona College, Salem',
      date: '18.02.2026'
    }
  ];
  associationPhotos: AssociationPhotoItem[] = [
  {
    image: 'assets/img/cs/aa1.jpeg',
    caption: ''
  },
  {
    image: 'assets/img/cs/aa2.jpeg',
    caption: ''
  }
];
  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return (
      this.tabs.find((tab) => tab.id === this.selectedTab)?.label ||
      'Department Profile'
    );
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}
}